export default "__VITE_ASSET__DyvWa$jd__"